import React, {useEffect, useMemo, useRef, useState} from "react";
import {widgetSrcChartList} from "./widgetSrcChart";
import {logDebug, logTrace} from "../../../utils/logger";
import {useAppContext} from "../../../AppDataContext";
interface TradingViewWidgetProps {
  symbol: string;
  interval?: string;
  timezone?: string;
  theme?: string;
  range?: string;
  style?: string;
  compared_symbols: string[];
  studies?: string[];
  action: string;
  chartKey?: string;
  volumeVisible?: boolean;
}

const TradingViewWidget:React.FC<TradingViewWidgetProps> = ({
   symbol ,
  theme,// = "Light",
  interval,// = "1d",
  timezone,// = "Etc/UTC",
  range,// = "12M",
  action,
  compared_symbols = [],
  style,
  volumeVisible,
    studies,
}) => {
  logDebug("TradingViewWidget component initialized with props", { symbol, theme, interval, timezone, range, action, compared_symbols, style, volumeVisible, studies });
  const elementRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState<number>(window.innerWidth);
   const [widthInframe, setWidthIframe] = useState<string>("65vw");
 const dataContext =  useAppContext()
  useEffect(() => {
    const updateWidth = () => {
      if (elementRef.current) {
        const breakpoints = [
          {maxWidth: 1100, width: "calc(100vw - 500px)"},
          {maxWidth: 600, width: "calc(100vw - 300px)"},
          {maxWidth: 0, width: "calc(100vw - 60px)"}// Default width
        ];

        const currentWidth = window.innerWidth;
        const matchingBreakpoint = breakpoints.find(breakpoint => currentWidth > breakpoint.maxWidth);

        if (matchingBreakpoint) {
          setWidth(elementRef.current.offsetWidth);
          setWidthIframe(matchingBreakpoint.width);
        }
      }
        logDebug({
          chart_width: width,
          window_width: window.innerWidth,
          proportions: width / window.innerWidth
        });
    };
    // Initial width update
    updateWidth();

    // Add event listener for window resize
    window.addEventListener('resize', updateWidth);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, []);


  const iframeSrc = useMemo(() => {
    const params = {
      autosize: true,
      symbol: symbol,
      interval : interval,
      timezone: timezone,
      theme : theme,
      style: style,
      locale: dataContext.language_for_chat? dataContext.language_for_chat.toLowerCase() : "en",
      range :  range,
      hide_side_toolbar: false,
      allow_symbol_change: false,
      calendar: false,
      compareSymbols: !Array.isArray(compared_symbols) || compared_symbols.length === 0 ? [] :compared_symbols.map((compSymbol) => ({symbol: compSymbol, position: "SameScale",})),
      studies: studies || [],
      show_popup_button: false,
      popup_width: "1000",
      popup_height: "650",
      hide_volume: !volumeVisible,
      support_host: "https://www.tradingview.com",
      utm_source: "localhost",
      utm_medium: "widget",
      utm_campaign: "advanced-chart",
      page_uri: "localhost:3000/",
    };
    logDebug("TradingViewWidget", params);
    const TVWIframeSrc = `${widgetSrcChartList[action]}?locale=${params.locale}#${encodeURIComponent(
      JSON.stringify(params))}`;
    logTrace("TVWIframeSrc=",TVWIframeSrc);
    return TVWIframeSrc
  }, [symbol, theme, interval, timezone, range, compared_symbols,studies, style, volumeVisible, action]);

  return (
      <div ref={elementRef} style={{width: widthInframe, margin: "0 auto"}}>
        <iframe
            src={iframeSrc}
            width= '100'
            height='500'
            allowFullScreen
            title="TradingView Advanced Chart"
            style={{ border: "none", width: "100%" }}
        ></iframe>
      </div>
  );
};

export default React.memo(TradingViewWidget);
